import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  useTheme,
} from "@mui/material";
import React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { useAddEnquiryMutation } from "state/api";
import { validationSchemaAdd } from "./validationSchema";
import { useFormik } from "formik";
import {
  customerResponses,
  carBrands,
  callStatuses,
  budgetRanges,
} from "./enquiryDropdowns";

const styles = {
  button: "bg-[#3671D5] hover:bg-[#114AAA] text-white ",
  cancelBtn: "bg-red-500 hover:bg-red-600 text-white",
};

const AddEnquiry = () => {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const formik = useFormik({
    initialValues: {
      carName: "",
      carCompany: "",
      customerName: "",
      customerNumber: "",
      customerEmail: "",
      customerCity: "",
      callStatus: "",
      customerResponse: customerResponses[0],
      nextFollowUpDate: null,
      // remarks: "",
      budget: budgetRanges[0],
    },
    validationSchema: validationSchemaAdd,
    onSubmit: (values) => {
      // submit the form using rtk query mutation and close the dialog
      addNewEnquiry(values)
        .unwrap()
        .then((res) => {
          alert("Enquiry added successfully");
        })
        .catch((err) => {
          alert("Error adding enquiry");
        });
      // above code can be replaced with a toast notification

      //   reset the form fields
      formik.resetForm();
      setOpen(false);
    },
  });
  const [addNewEnquiry] = useAddEnquiryMutation();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Button
        variant="contained"
        size="large"
        className="bg-[#1A1A20] text-gray-50 hover:bg-slate-700"
        onClick={handleClickOpen}
      >
        Add Query
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        sx={{
          "& .MuiDialog-paper": {
            backgroundColor: theme.palette.background.default,
            color: theme.palette.text.primary,
          },
          // change label color
          "& .MuiInputLabel-root": {
            color: theme.palette.primary[300],
          },
        }}
        maxWidth="md"
      >
        <form onSubmit={formik.handleSubmit}>
          <DialogTitle id="form-dialog-title">Add Enquiry</DialogTitle>
          <DialogContent>
            <DialogContentText>
              To add new enquiry, please enter the details here.
            </DialogContentText>
            <div className="grid grid-cols-2 gap-4 mb-4 p-2">
              <TextField
                margin="dense"
                id="customerName"
                label="Customer Name"
                type="text"
                fullWidth
                value={formik.values.customerName}
                onChange={formik.handleChange}
                error={
                  formik.touched.customerName &&
                  Boolean(formik.errors.customerName)
                }
                helperText={
                  formik.touched.customerName && formik.errors.customerName
                }
              />
              <TextField
                margin="dense"
                id="customerNumber"
                label="Customer Number"
                type="text"
                fullWidth
                value={formik.values.customerNumber}
                onChange={formik.handleChange}
                error={
                  formik.touched.customerNumber &&
                  Boolean(formik.errors.customerNumber)
                }
                helperText={
                  formik.touched.customerNumber && formik.errors.customerNumber
                }
              />
              <TextField
                margin="dense"
                id="customerEmail"
                label="Customer Email"
                type="text"
                fullWidth
                value={formik.values.customerEmail}
                onChange={formik.handleChange}
                error={
                  formik.touched.customerEmail &&
                  Boolean(formik.errors.customerEmail)
                }
                helperText={
                  formik.touched.customerEmail && formik.errors.customerEmail
                }
              />
              <TextField
                margin="dense"
                id="customerCity"
                label="Customer City"
                type="text"
                fullWidth
                value={formik.values.customerCity}
                onChange={formik.handleChange}
                error={
                  formik.touched.customerCity &&
                  Boolean(formik.errors.customerCity)
                }
                helperText={
                  formik.touched.customerCity && formik.errors.customerCity
                }
              />

              <Autocomplete
                margin="dense"
                id="carCompany"
                options={carBrands}
                getOptionLabel={(option) => option}
                onChange={(event, newValue) => {
                  formik.setFieldValue("carCompany", newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    margin="dense"
                    {...params}
                    label="Car Company"
                    error={
                      formik.touched.carCompany &&
                      Boolean(formik.errors.carCompany)
                    }
                    helperText={
                      formik.touched.carCompany && formik.errors.carCompany
                    }
                  />
                )}
              />
              <TextField
                margin="dense"
                id="carName"
                label="Car Name"
                type="text"
                fullWidth
                value={formik.values.carName}
                onChange={formik.handleChange}
                error={formik.touched.carName && Boolean(formik.errors.carName)}
                helperText={formik.touched.carName && formik.errors.carName}
              />

              <TextField
                margin="dense"
                id="leadSource"
                label="Lead Source"
                type="text"
                fullWidth
                value={formik.values.leadSource}
                onChange={formik.handleChange}
                error={formik.touched.leadSource && Boolean(formik.errors.leadSource)}
                helperText={formik.touched.leadSource && formik.errors.leadSource}
              />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DateTimePicker"]}>
                  {/* <DatePicker
                    label="Next Follow-up Date"
                    format="LL"
                    value={formik.values.nextFollowUpDate}
                    onChange={(newValue) => {
                      formik.setFieldValue("nextFollowUpDate", newValue);
                    }}
                    slotProps={{
                      textField: {
                        error:
                          formik.touched.nextFollowUpDate &&
                          Boolean(formik.errors.nextFollowUpDate),
                        helperText:
                          formik.touched.nextFollowUpDate &&
                          formik.errors.nextFollowUpDate,
                      },
                    }}
                  /> */}
                  <DateTimePicker
                    label="Next Follow-up Time"
                    format="LL hh:mm a"
                    value={formik.values.nextFollowUpDate}
                    onChange={(newValue) => {
                      formik.setFieldValue("nextFollowUpDate", newValue);
                    }}
                    slotProps={{
                      textField: {
                        error:
                          formik.touched.nextFollowUpDate &&
                          Boolean(formik.errors.nextFollowUpDate),
                        helperText:
                          formik.touched.nextFollowUpDate &&
                          formik.errors.nextFollowUpDate,
                        
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              <Autocomplete
                margin="dense"
                id="callStatus"
                options={callStatuses}
                getOptionLabel={(option) => option}
                onChange={(event, newValue) => {
                  formik.setFieldValue("callStatus", newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    margin="dense"
                    {...params}
                    label="Call Status"
                    error={
                      formik.touched.callStatus &&
                      Boolean(formik.errors.callStatus)
                    }
                    helperText={
                      formik.touched.callStatus && formik.errors.callStatus
                    }
                  />
                )}
              />
              <Autocomplete
                margin="dense"
                id="customerResponse"
                options={customerResponses}
                getOptionLabel={(option) => option}
                onChange={(event, newValue) => {
                  formik.setFieldValue("customerResponse", newValue);
                }}
                defaultValue={customerResponses[0]}
                renderInput={(params) => (
                  <TextField
                    margin="dense"
                    {...params}
                    label="Customer Response"
                    error={
                      formik.touched.customerResponse &&
                      Boolean(formik.errors.customerResponse)
                    }
                    helperText={
                      formik.touched.customerResponse &&
                      formik.errors.customerResponse
                    }
                  />
                )}
              />
              <Autocomplete
                margin="dense"
                id="budget"
                options={budgetRanges}
                getOptionLabel={(option) => option}
                onChange={(event, newValue) => {
                  formik.setFieldValue("budget", newValue);
                }}
                defaultValue={budgetRanges[0]}
                renderInput={(params) => (
                  <TextField
                    margin="dense"
                    {...params}
                    label="Budget"
                    error={
                      formik.touched.budget && Boolean(formik.errors.budget)
                    }
                    helperText={formik.touched.budget && formik.errors.budget}
                  />
                )}
              />
            </div>
            {/* <TextField
              margin="dense"
              id="remarks"
              label="Remarks"
              type="text"
              fullWidth
              value={formik.values.remarks}
              onChange={formik.handleChange}
              error={formik.touched.remarks && Boolean(formik.errors.remarks)}
              helperText={formik.touched.remarks && formik.errors.remarks}
            /> */}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} className={styles.cancelBtn}>
              Cancel
            </Button>
            <Button type="submit" className={styles.button}>
              Add
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

export default AddEnquiry;
